export const getGroupSessionLoading =  ({store})  => store.groupSessionTutorReducer.loading;

export const getGroupSessionError =  ({store})  => store.groupSessionTutorReducer.error;

export const getGroupSessionData =  ({store})  => store.groupSessionTutorReducer.data;